// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"9de2e369","356":"9de2e369","601":"9de2e369","922":"b522e319","957":"3f5ed626"}[chunkId] + ".chunk.css";
};